import { useAuthStore } from './auth.store';

export const useActiveToken = () => {
  return useAuthStore((s) => s.activeToken);
};
